import React from 'react';
import { Box } from '@mui/material';
import { CardCompact } from '../../TemplateManagerDashboard/components';

/**
 * TemplatesGrid Component
 *
 * Grid layout for displaying template cards.
 *
 * @param {Object} props
 * @param {Array} props.templates - Array of template objects
 * @param {Function} props.onEdit - Handler for editing a template
 * @param {Function} props.onExecute - Handler for executing a template
 * @param {Function} props.onOpenVersions - Handler for opening template versions
 * @param {Function} props.onOpenExecutions - Handler for opening execution history
 * @param {Function} props.onDelete - Handler for deleting a template
 * @param {Function} props.onCreateExperiment - Handler for creating an experiment
 * @param {Function} props.onViewAnalytics - Handler for viewing analytics
 * @param {Function} props.onOpenFeedback - Handler for opening feedback dialog
 */
function TemplatesGrid({
  templates,
  onEdit,
  onExecute,
  onOpenVersions,
  onOpenExecutions,
  onDelete,
  onCreateExperiment,
  onViewAnalytics,
  onOpenFeedback,
}) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
        },
        gap: 3,
        width: '100%',
        alignItems: 'stretch',
      }}
    >
      {templates.map(template => (
        <Box
          key={template.id || template.template_id}
          sx={{
            display: 'flex',
            minWidth: 0,
            width: '100%',
          }}
        >
          <CardCompact
            template={template}
            analytics={template} // Analytics are already on the template object from MV
            onEdit={() => onEdit(template)}
            onExecute={() => onExecute(template)}
            onOpenVersions={() => onOpenVersions(template)}
            onOpenExecutions={() => onOpenExecutions(template)}
            onDelete={() => onDelete(template)}
            onCreateExperiment={() => onCreateExperiment(template)}
            onViewAnalytics={() => onViewAnalytics(template)}
            onOpenFeedback={() => onOpenFeedback(template)}
            // Common hover styles are now applied via CardCompact component
            // No need for custom hoverShadow - matches template version select hover effect
            sx={{
              width: '100%',
              minWidth: 0,
              maxWidth: '100%',
            }}
            showAnalytics={true}
          />
        </Box>
      ))}
    </Box>
  );
}

export default TemplatesGrid;
